import { DefaultCellHeader } from "app/components/React/Table/headerCells";
import { i18nFilter } from "app/filters/i18nFilter";
import { WebsiteTooltipTopCell } from "app/components/React/Table/cells";

export const searchOverviewTopWidgetTableConfig = (fieldName, displayName, trendCall) => [
    {
        field: "Domain",
        displayName: i18nFilter()("Search.overview.top.widget.table.compare.domain.header"),
        headerComponent: DefaultCellHeader,
        cellComponent: WebsiteTooltipTopCell,
        width: "50%",
        tableOptions: { colorSource: "compareMainColors" },
    },
    {
        field: fieldName,
        displayName: i18nFilter()(displayName),
        headerComponent: DefaultCellHeader,
        cellComponent: trendCall,
        width: "48%",
        tableOptions: { colorSource: "compareMainColors" },
        format: "abbrNumber",
        displayNumberLeft: true,
    },
];
